import { useDispatch, useSelector, useStore } from 'react-redux';
// ** React Imports
import { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';

// ** Third Party Components
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

// ** Reactstrap Imports
import { Badge } from 'reactstrap';
import { useLogout } from '../../../../../store/Auth/authHooks';
import { useAppSelector } from '../../../../../store/hooks';
import { MODAL_NAMESPACE } from '../../../../../store/modal/modalReducer';
import { SUPPORT_NAMESPACE } from '../../../../../store/support-management/SupportReducer';
import { EventState } from '../../../../../store/events/eventTypes';
import { EVENT_NAMESPACE } from '../../../../../store/events/eventReducer';
import { store } from '../../../../../store/store';
import useShowComingSoon from '../../../../../utility/hooks/useShowComingSoon';

const VerticalNavMenuLink = ({
  item,
  activeItem,
  setActiveItem,
  currentActiveItem,
  isLogoutButton,
  action,
}) => {
  //TODO remove
  // Only for develop
  const [showComingSoon] = useShowComingSoon();

  // ** Conditional Link Tag, if item has newTab or externalLink props use <a> tag else use NavLink
  const LinkTag = item.externalLink ? 'a' : NavLink;

  const dispatch = useDispatch();

  // ** Hooks
  const { t } = useTranslation();
  const location = useLocation();
  const logout = useLogout();
  const history = useHistory();

  useEffect(() => {
    if (currentActiveItem) {
      setActiveItem(currentActiveItem);
    }
  }, [location]);

  const onClickLogout = () => {
    logout();
  };

  return (
    <li
      className={classnames({
        'nav-item-logout': isLogoutButton,
        'nav-item': !item.children,
        'hide-on-mobile': item.className,
        disabled: item.disabled,
        active: item.navLink === activeItem,
      })}
    >
      <LinkTag
        title={item.comingSoon ? t('COMING_SOON_TEXT') : t(item.title)}
        className={classnames([
          'd-flex',
          'align-items-center',
          { 'menu-item-coming-soon': item.comingSoon && !showComingSoon },
        ])}
        target={item.newTab ? '_blank' : undefined}
        /*eslint-disable */
        {...(item.externalLink === true
          ? {
              href: item.navLink || '/',
            }
          : {
              to: item.navLink || '/',
              isActive: (match) => {
                if (!match) {
                  return false;
                }

                if (
                  match.url &&
                  match.url !== '' &&
                  match.url === item.navLink
                ) {
                  currentActiveItem = item.navLink;
                }
              },
            })}
        onClick={(e) => {
          if (
            item.navLink?.length === 0 ||
            item.navLink === '#' ||
            item.disabled === true ||
            isLogoutButton ||
            item.action ||
            (item.comingSoon && !showComingSoon)
          ) {
            e.preventDefault();
            if (item.comingSoon) {
              return;
            }
            if (isLogoutButton) {
              onClickLogout();
            }
            if (item.action) {
              item.action(dispatch, store.getState(), history, t);
            }
          }
        }}
      >
        {item.icon}
        <span className="menu-item text-truncate">{t(item.title)}</span>

        {item.badge && item.badgeText ? (
          <Badge className="ms-auto me-1" color={item.badge} pill>
            {item.badgeText}
          </Badge>
        ) : null}
      </LinkTag>
    </li>
  );
};

export default VerticalNavMenuLink;
